{
    "WLD": "world",
    "GLB": "world",
    "USA": "us"
}
